import { IAttribute } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { SapEccResourceDataset } from 'app/model/dataset/sap-ecc-resource.dataset';
import { TabularCopySource } from './tabular-type.copysource';

import { Constants } from 'app/shared/shared-constants';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.sapecc.copySourceType,
    display: [],
    tags: {
        datasetModel: [
            Metamodel.modelFor(SapEccResourceDataset)
        ]
    }
})
export class SapEccCopySource extends TabularCopySource {
    public static readonly HTTP_REQUEST_TIMEOUT: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'HTTP_REQUEST_TIMEOUT',
        display: `${stringResources.ModelName_Request_Timeout}`,
        constraint: {
            pattern: Constants.timeoutValidation
        }
    })
    public httpRequestTimeout?: string = '00:05:00';
}
